import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import LandingDetail from "./LandingDetail";
import Counts from "./Counts";
import Reviews from "./Reviews";

const Landing = () => {
  <Helmet>
    <title>Trans World Shipping Company - Home</title>
    <meta
      name="description"
      content="Trans World shipping Company is a leading provider of logistics and transportation services, offering efficient and reliable solutions for businesses worldwide."
    />
    <description>
      Trans World shipping Company is a leading provider of logistics and transportation
      services, offering efficient and reliable solutions for businesses
      worldwide.
    </description>
  </Helmet>;
    return <>
      <HeroSection/>
        <LandingDetail />
        <Counts />
        <Reviews/>
  </>;
};

export default Landing;
